export const navigation = 'Navigation';
export const home = 'Accueil';
export const about = 'À propos';
export const contact = 'Contact';
export const language = 'Langue';
export const english = 'English';
export const french = 'Français';

// Home page
export const welcomeTitle = 'Portfolio de Design Créatif';
export const welcomeSubtitle = 'Découvrez mes derniers projets de design et œuvres créatives';
export const viewGallery = 'Voir la Galerie';
export const learnMore = 'En Savoir Plus';

// Gallery page
export const galleryTitle = 'Ma Galerie de Design';
export const gallerySubtitle = 'Une collection de mes œuvres créatives et projets de design';
export const allProjects = 'Tous les Projets';
export const webDesign = 'Design Web';
export const wildCherry = 'Image de Marque';
export const illustration = 'Illustration';
export const photography = 'Photographie';
export const viewProject = 'Voir le Projet';

// About page
export const aboutTitle = 'À Propos';
export const aboutSubtitle = 'Directrice Artistique - Frenchette Group';
export const aboutDescription = 'Je suis directrice artistique et consultante spécialisée dans le développement de marque chez Frenchette Group. Mon implication couvre un domaine exclusif englobant tous les établissements sous l\'égide du groupe Frenchette : Frenchette, Frenchette Bakery, Le Rock, Frenchette Bakery At The Whitney, Le Veau d\'Or, et plus récemment WILD CHERRY en collaboration avec A24 Entertainment au théâtre historique de Cherry Lane. Mes services incluent la visualisation de concepts, l\'art graphique, la conception de menus, la conservation musicale, les campagnes sur les réseaux sociaux et les stratégies promotionnelles. Je fournis des solutions créatives et novatrices à des défis uniques, en mettant l\'accent sur les valeurs fondamentales et l\'identité de la marque du groupe Frenchette.';
export const aboutServices = '• Graphisme\n• Illustration\n• Design de Menu\n• Marchandisage\n• Développement de Nom et Concept\n• Image de Marque Complète - WILD CHERRY\n• Typographie - WILD CHERRY, Le Veau d\'Or';
export const skills = 'Compétences';
export const experience = 'Expérience';
export const yearsExperience = 'Années d\'Expérience';

// Contact page
export const contactTitle = 'Contactez-Moi';
export const contactSubtitle = 'Planifier une Discussion';
export const name = 'Nom';
export const email = 'Email';
export const message = 'Message';
export const sendMessage = 'Envoyer le Message';
export const contactInfo = 'Informations de Contact';
export const phone = 'Téléphone';
export const location = 'Localisation';

// Le Veau d'Or page
export const leVeauDorCaption = 'Regardez la typographie en action.';

// Le Rock page
export const leRockCaption = 'Graphique du réveillon du Nouvel An pour LE ROCK.';

// Frenchette page
export const frenchetteCaption = 'Graphiques pour diverses facettes de la marque Frenchette. Logo original "frenchette" conçu par Mucca Design.';

export default {
  navigation,
  home,
  about,
  contact,
  language,
  english,
  french,
  welcomeTitle,
  welcomeSubtitle,
  viewGallery,
  learnMore,
  galleryTitle,
  gallerySubtitle,
  allProjects,
  webDesign,
  wildCherry,
  illustration,
  photography,
  viewProject,
  aboutTitle,
  aboutSubtitle,
  aboutDescription,
  aboutServices,
  skills,
  experience,
  yearsExperience,
  contactTitle,
  contactSubtitle,
  name,
  email,
  message,
  sendMessage,
  contactInfo,
  phone,
  location,
  leVeauDorCaption,
  leRockCaption,
  frenchetteCaption
};
